// Local storage utility for managing downloaded articles

const STORAGE_KEY = 'smartreadgo_downloaded_articles';

export const saveArticleToLibrary = (article) => {
  try {
    const existingArticles = getDownloadedArticles();
    
    // Check if article already exists
    const exists = existingArticles.some(a => a.id === article.id);
    if (exists) {
      console.log('Article already in library');
      return { success: false, message: 'Article already downloaded' };
    }
    
    // Add download timestamp
    const articleWithTimestamp = {
      ...article,
      downloadedAt: new Date().toISOString()
    };
    
    existingArticles.push(articleWithTimestamp);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(existingArticles));
    
    console.log('Article saved to library:', article.title);
    return { success: true, message: 'Article downloaded successfully' };
  } catch (error) {
    console.error('Error saving article:', error);
    return { success: false, message: 'Failed to download article' };
  }
};

export const getDownloadedArticles = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    return JSON.parse(stored);
  } catch (error) {
    console.error('Error getting downloaded articles:', error);
    return [];
  }
};

export const removeArticleFromLibrary = (articleId) => {
  try {
    const existingArticles = getDownloadedArticles();
    const filteredArticles = existingArticles.filter(a => a.id !== articleId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filteredArticles));
    
    console.log('Article removed from library:', articleId);
    return { success: true, message: 'Article deleted successfully' };
  } catch (error) {
    console.error('Error removing article:', error);
    return { success: false, message: 'Failed to delete article' };
  }
};

export const isArticleDownloaded = (articleId) => {
  const articles = getDownloadedArticles();
  return articles.some(a => a.id === articleId);
};

export const clearAllDownloads = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return { success: true, message: 'All downloads cleared' };
  } catch (error) {
    console.error('Error clearing downloads:', error);
    return { success: false, message: 'Failed to clear downloads' };
  }
};

export const getLibraryStats = () => {
  const articles = getDownloadedArticles();
  return {
    total: articles.length,
    categories: [...new Set(articles.map(a => a.category))],
    sources: [...new Set(articles.map(a => a.source))],
  };
};